// npm
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);
import { Splide } from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

// css
import '../../scss/pages/page-data.scss';

// libs
import DataMouseStalker from '../_libs/DataMouseStalker';
import RecruitFV from '../_libs/RecruitFV';

// utils
import Ease from '../_utils/Ease';
import { getCssVar } from '../_utils/Utils';
import RecruitFoundation from '../_utils/RecruitFoundation';
RecruitFoundation();

document.addEventListener('DOMContentLoaded', () => {
	const $whatBackground = document.querySelector('.js-what-background');
	if ($whatBackground) {
		const $$text = document.querySelectorAll('.js-what-background-text');

		gsap.set($$text, {
			xPercent: 2,
			yPercent: 120,
		});

		const observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						gsap.to($$text, {
							xPercent: 0,
							yPercent: 0,
							duration: 1.2,
							ease: Ease.gleasing,
						});

						observer.disconnect();
					}
				});
			},
			{
				rootMargin: '-30% 0px -30% 0px',
			}
		);

		observer.observe($whatBackground);
	}

	const whatSplide = new Splide('.js-what-splide', {
		arrows: false,
		drag: 'free',
		type: 'loop',
		pagination: false,
		autoScroll: {
			speed: 0.3,
			pauseOnFocus: false,
			pauseOnHover: false,
		},
		mediaQuery: 'min',
		breakpoints: {
			768: {
				fixedWidth: '502rem',
				autoScroll: {
					speed: 0.2,
				},
			},
		},
	});
	whatSplide.mount({ AutoScroll });

	const $whatPopup = document.querySelector('.js-what-splide-popup');
	whatSplide.on('drag', () => {
		if (!$whatPopup.classList.contains('is-hide')) {
			$whatPopup.classList.add('is-hide');
		}

		whatSplide.root.classList.add('is-drag');
		document.documentElement.classList.add('is-drag');
	});

	whatSplide.on('dragged', () => {
		whatSplide.root.classList.remove('is-drag');
		document.documentElement.classList.remove('is-drag');
	});

	whatSplide.root.addEventListener('mousedown', () => {
		if (!$whatPopup.classList.contains('is-hide')) {
			$whatPopup.classList.add('is-hide');
		}

		whatSplide.root.classList.add('is-drag');
		document.documentElement.classList.add('is-drag');
	});

	whatSplide.root.addEventListener('mouseup', () => {
		whatSplide.root.classList.remove('is-drag');
		document.documentElement.classList.remove('is-drag');
	});

	const $data = document.querySelector('.js-data');
	if ($data) {
		const $$item = $data.querySelectorAll('.js-data-item');

		$$item.forEach(($item) => {
			const $indexNumber = $item.querySelector(
				'.js-data-item-index-number'
			);
			const $indexText = $item.querySelector('.js-data-item-index-text');
			const $body = $item.querySelector('.js-data-item-body');

			$item.classList.add('is-init');

			gsap.set($indexNumber, {
				opacity: 0,
				xPercent: -10,
			});

			gsap.set($indexText, {
				opacity: 0,
			});

			gsap.set($body, {
				opacity: 0,
				y: 10,
			});

			const observer = new IntersectionObserver(
				(entries) => {
					entries.forEach((entry) => {
						if (entry.isIntersecting) {
							const tl = gsap.timeline();

							tl.to($item, {
								opacity: 1,
								duration: 0.4,
								ease: Ease.DoubleSineOut,
							});

							tl.to(
								$indexNumber,
								{
									opacity: 1,
									xPercent: 0,
									duration: 0.4,
									ease: Ease.DoubleSineOut,
								},
								'<'
							);

							tl.to($indexText, {
								opacity: 1,
								duration: 0.4,
								ease: Ease.DoubleSineOut,
							});

							tl.to($body, {
								opacity: 1,
								y: 0,
								duration: 0.4,
								ease: Ease.DoubleSineOut,
								onStart: () => {
									entry.target.classList.add('is-active');
								},
							});

							observer.disconnect();
						}
					});
				},
				{
					rootMargin: '0px 0px -20% 0px',
				}
			);

			observer.observe($item);
		});
	}

	const $talk = document.querySelector('.js-talk');
	if ($talk) {
		// 見出し
		const $headline = $talk.querySelector('.js-talk-headline');
		gsap.set($headline, {
			opacity: 1,
		});
		gsap.fromTo(
			'.js-talk-headline-en-text',
			{
				yPercent: 120,
			},
			{
				yPercent: 0,
				duration: 1,
				ease: Ease.gleasing,
				scrollTrigger: {
					trigger: $headline,
					start: 'top 70%',
				},
			}
		);
		gsap.fromTo(
			'.js-talk-headline-ja',
			{
				yPercent: 10,
				opacity: 0,
			},
			{
				yPercent: 0,
				opacity: 1,
				duration: 1,
				ease: Ease.gleasing,
				scrollTrigger: {
					trigger: $headline,
					start: 'top 70%',
				},
			}
		);

		// チャット見出し
		// gsap.fromTo(
		// 	'.js-talk-chat-top',
		// 	{
		// 		opacity: 0,
		// 	},
		// 	{
		// 		opacity: 1,
		// 		duration: 0.4,
		// 		ease: Ease.DoubleSineOut,
		// 		overwrite: true,
		// 	}
		// );

		ScrollTrigger.create({
			trigger: '.js-talk-trigger-chat-top',
			start: 'top bottom',
			end: 'bottom bottom',
			markers: false,
			onEnter: () => {
				gsap.fromTo(
					'.js-talk-chat-top',
					{
						opacity: 0,
						y: 0,
					},
					{
						opacity: 1,
						duration: 0.4,
						ease: Ease.DoubleSineOut,
						overwrite: true,
					}
				);
			},
			onEnterBack: () => {
				gsap.fromTo(
					'.js-talk-chat-top',
					{
						opacity: 0,
						y: 0,
					},
					{
						opacity: 1,
						duration: 0.4,
						ease: Ease.DoubleSineOut,
						overwrite: true,
					}
				);
			},
			onLeave: () => {
				gsap.fromTo(
					'.js-talk-chat-top',
					{
						opacity: 1,
						y: 0,
					},
					{
						y: -20,
						opacity: 0,
						duration: 0.4,
						ease: Ease.DoubleSineOut,
					}
				);
			},
			onLeaveBack: () => {
				gsap.fromTo(
					'.js-talk-chat-top',
					{
						opacity: 1,
						y: 0,
					},
					{
						opacity: 0,
						duration: 0.4,
						ease: Ease.DoubleSineOut,
					}
				);
			},
		});

		// チャットを１つずつ表示
		const $headerEntry = document.querySelector('.js-header-entry');
		const $chatList = document.querySelector('.js-talk-chat-list');
		const $$chatItem = document.querySelectorAll('.js-talk-chat-item');
		const $chatItemTrigger = document.querySelector(
			'.js-talk-trigger-chat-item'
		);
		$$chatItem.forEach(($chatItem, index) => {
			const $childTrigger = document.createElement('div');
			$childTrigger.classList.add('js-talk-trigger-chat-item-child');
			$chatItemTrigger.appendChild($childTrigger);

			$chatItem.setAttribute('data-id', String(index + 1));
			$childTrigger.setAttribute('data-id', String(index + 1));
		});

		const $$triggerChatItemChild = document.querySelectorAll(
			'.js-talk-trigger-chat-item-child'
		);

		let chatListY = $headerEntry.clientHeight;

		$$triggerChatItemChild.forEach(($trigger, i) => {
			const id = $trigger.getAttribute('data-id');
			const $target = document.querySelector(
				`.js-talk-chat-item[data-id="${id}"]`
			);

			const y = $target.clientHeight;

			chatListY += y;

			gsap.set($target, {
				'--_chat-item-y': chatListY + 'px',
			});

			ScrollTrigger.create({
				trigger: $trigger,
				start: 'top center',
				end: 'top center',
				markers: false,
				onEnter: () => {
					const y = String(getCssVar($target, '--_chat-item-y'));
					gsap.set($chatList, {
						'--_chat-item-y': y,
					});

					$target.classList.add('is-active');
				},
				onEnterBack: () => {
					if (i === 0) {
						gsap.set($chatList, {
							'--_chat-item-y': 0,
						});
					} else {
						const $prevTarget = document.querySelector(
							`.js-talk-chat-item[data-id="${i}"]`
						);
						const y = String(
							getCssVar($prevTarget, '--_chat-item-y')
						);

						gsap.set($chatList, {
							'--_chat-item-y': y,
						});
					}

					$target.classList.remove('is-active');
				},
			});
		});
	}
});

window.addEventListener('load', () => {
	ScrollTrigger.refresh();

	RecruitFV();

	DataMouseStalker();
});

let vw = document.documentElement.clientWidth;
window.addEventListener('resize', () => {
	if (vw === document.documentElement.clientWidth) {
		return;
	}
	vw = document.documentElement.clientWidth;
	location.reload();
});
